import { countries } from '../../constants/countries';
import { addArrayListFilter } from '../../helpers/listHelper';

// Gift Aid only exists for United Kingdom charities, so these filters are
// added to the donation list at render time rather than to the static
// availableFiltersKeys.
export const giftAidFiltersKeys = [
  'donor.giftAid',
  'donor.giftAidClaim.status'
];

interface GiftAidFilterAccess {
  isUkCharityEnabled: boolean;
  isSystemAdmin: boolean;
  organizationCountry?: string | null;
}

const isGbCountry = (country?: string | null) =>
  !!country &&
  countries[country.toUpperCase() as keyof typeof countries] === countries.GB;

// System admins search across every organisation, UK charities included, so
// they get the filters whenever the UK charity flag is on.
export const canFilterByGiftAid = ({
  isUkCharityEnabled,
  isSystemAdmin,
  organizationCountry
}: GiftAidFilterAccess) =>
  isUkCharityEnabled && (isSystemAdmin || isGbCountry(organizationCountry));

export const getListWithGiftAidFilters = <
  T extends { availableFiltersKeys: string[] }
>(
  list: T,
  access: GiftAidFilterAccess
): T => {
  if (!list || !canFilterByGiftAid(access)) {
    return list;
  }
  return addArrayListFilter(list, giftAidFiltersKeys);
};
